import { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import DeleteDraftDropdown from './DeleteDraftDropdown';

function CompetitionStatus({ status, id }) {
  const [variant, setVariant] = useState('');

  const setColor = () => {
    switch (status) {
      case 'Kommande':
        setVariant('warning');
        break;
      case 'Avslutad':
        setVariant('blue');
        break;
      case 'Pågående':
        setVariant('success');
        break;
      case 'Påbörjad':
        setVariant('primary');
        break;
      case 'Inställd':
        setVariant('danger');
        break;
    }
  };

  useEffect(() => {
    setColor();
  }, [status]);

  return status === 'Utkast' ? (
    <DeleteDraftDropdown id={id} />
  ) : (
    <Badge
      bg={variant}
      className={`p-2 ${
        variant === 'warning' || variant === 'danger' ? 'text-black' : ''
      }`}
    >
      {status}
    </Badge>
  );
}

export default CompetitionStatus;
